import React from 'react'
import { Breadcrumbs, styled } from '@mui/material'

export const StyledBreadcrumbs = styled(Breadcrumbs)(({ theme }) => ({
    color: theme.palette.text.primary,
    marginBottom: theme.spacing(2),

    // Breadcrumb links
    '& a': {
        cursor: 'pointer',
        color: theme.palette.grey[600],
        textDecoration: 'none',
        '&:hover': {
            color: theme.palette.grey[800],
            textDecoration: 'underline',
        },
    },

    // Current breadcrumb
    '& .current': {
        fontWeight: 500,
        backgroundColor: theme.palette.grey[200],
        padding: '0 2px',
        borderRadius: theme.shape.borderRadius,
    },

    // Separator
    '& .MuiBreadcrumbs-separator': {
        fontWeight: 'bold',
        color: theme.palette.text.primary,
    },
}))
